export default __webpack_public_path__ + "static/media/fandeck.274b7b0d.svg";